import { Channel } from '../types';

const sendMessage = ({
  messageId,
  value,
  type,
  mainChannels,
  requestChannels,
  setMainChannels,
  setRequestChannels,
}: {
  messageId: string;
  value?: string;
  setMainChannels: (channels: Channel[]) => void;
  setRequestChannels: (channels: Channel[]) => void;
  type: 'main' | 'requests';
  mainChannels?: Channel[];
  requestChannels?: Channel[];
}) => {
  if (type === 'main') {
    const nextMainChannels = mainChannels?.map((item) => {
      const result = { ...item };

      if (result.id === messageId) {
        result.messages = {
          edges: [
            {
              node: {
                channelId: messageId,
                content: value || 'Document uploaded',
                createdAt: new Date().toISOString(),
              },
            },
          ],
        };
      }

      return result;
    });

    setMainChannels(nextMainChannels as Channel[]);
  } else {
    const nextRequestChannels = requestChannels?.map((item) => {
      const result = { ...item };

      if (result.id === messageId) {
        result.messages = {
          edges: [
            {
              node: {
                channelId: messageId,
                content: value || 'Document uploaded',
                createdAt: new Date().toISOString(),
              },
            },
          ],
        };
      }

      return result;
    });

    setRequestChannels(nextRequestChannels as Channel[]);
  }
};

export default sendMessage;
